// Draft resume loudness (Wave 2 board Call 4): a draft saved in THIS session resumes with
// a primary-style Schedule now; older drafts resume quietly, so the hub never carries two
// loud controls. Freshness is deliberately session membership, not a timestamp rule, so
// the set lives for the page's JS lifetime and nothing is persisted.
//
// Module-level on purpose: the save happens in two places (the wizard's Define step and
// the Templates drawer form) and the cue renders in a third (the Templates list). One
// shared set keeps all three honest without threading page state through every seam.

const savedThisSession = new Set<string>();

/** Record that this operator saved this draft in this session. */
export function markDraftSavedThisSession(templateId: string): void {
  if (templateId.length > 0) {
    savedThisSession.add(templateId);
  }
}

/** The set `draftResumeTone` / `draftResumeCue` read. Live reference, do not mutate. */
export function draftsSavedThisSession(): ReadonlySet<string> {
  return savedThisSession;
}

/** Test isolation only. */
export function resetDraftsSavedThisSession(): void {
  savedThisSession.clear();
}
